/* eslint-disable no-self-assign */
/* eslint-disable require-yield */

// import get from 'lodash/get'
import planApi from '@/api/plan'
import get from 'lodash/get'

const INITIAL_STATE = {
  planList: null
}

export default {
  namespace: 'plan',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    setPlanDetails(state, { payload }) {
      return { ...state, planDetails: payload }
    },
    setPlanData(state, { payload }) {
      return { ...state, planList: payload }
    },
  },

  effects: {
    *getPlanDetails({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(planApi.getPlanDetails, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'plan/setPlanDetails', payload: resData.data })
        successCallback?.()
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getPlanLevel({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(planApi.getPlanLevel, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getPlanData({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(planApi.getPlanData, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false
        yield put({ type: 'plan/setPlanData', payload: resData })
        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *createPlan({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(planApi.createPlan, {
        data: {
          ...payload,
        },
        params: { accountId: get(account, 'accountId') },
      })

      const { status } = response

      if (status === 200) {
        successCallback?.()
      } else {
        errorCallback?.()
      }
    },

    *editPlan({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(planApi.editPlan, {
        data: {
          ...payload,
        },
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        const { success } = resData
        if (success) {
          hasError = false
          successCallback?.()
        }
      }

      if (hasError) {
        yield put({ type: 'app/notify', payload: { message: resData?.message, severity: 'error' } })
        errorCallback?.(resData?.message)
      }
    },

    *deletePlan({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(planApi.deletePlan, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },
  },
}
